import { last } from 'remeda'

const IMAGE_WIDTHS = [32, 96, 128, 256, 384, 640, 750, 828, 1080, 1200, 1920, 2048, 3840] as const
const MAX_WIDTH = last(IMAGE_WIDTHS)
type ImageWidth = (typeof IMAGE_WIDTHS)[number]

/**
 * I am pretty sure we put the +2 size jump hack in because we didn't realize about device pixel ratio. works. I'm going
 * to go without it for modweb and trust we use the correct sizes.
 */
export function findClosestImageWidthWithSizeJumpHack(width: number): ImageWidth {
  const index = IMAGE_WIDTHS.findIndex((w) => w > width)
  const newWidth = index === -1 ? undefined : IMAGE_WIDTHS[index + 2]
  return newWidth ?? MAX_WIDTH
}

export function findClosestImageWidth(width: number): ImageWidth {
  return IMAGE_WIDTHS.find((w) => w >= width) ?? MAX_WIDTH
}
